/**
 * Affinity Teaser.
 */

import { Component, registerComponent } from 'js/component.js';
import Carousel from '../../../../carousel/clientlibs/site/js/carousel.js';

const componentName = 'cmp-experiencefragment-ajax';
export class ExperienceFragmentAjax extends Component {

    async getXFContent(xfPath) {
        let xfContent;
        const isAuthorEnv = getCookie('cq-authoring-mode');
        const uri = `${xfPath}.html`;

        try {
            const response = await fetch(`${uri}${isAuthorEnv ? '?wcmmode=disabled' : ''}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            xfContent = await response.text();
        } catch (e) {
            console.error('Cannot load experience fragment content');
        }

        return xfContent;
    }

    /**
     * Initialize Component.
     */
    async init() {
        const { xfPath } = this.element.dataset;
        const xfContent = await this.getXFContent(xfPath);
        this.element.innerHTML = xfContent;
        const carousel = this.element.querySelector('.carousel');

        if (carousel) {
            new Carousel(carousel).init();
        }
    }
}

function getCookie(name) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
}

registerComponent(`.${componentName}`, ExperienceFragmentAjax);
